// extracted by mini-css-extract-plugin
export var boldText = "_8d-4";
export var checkboxContainer = "_8d-6";
export var closeIcon = "_8d-i";
export var container = "_8d-0";
export var drawer = "_8d-8";
export var drawerContent = "_8d-9";
export var extraSmallText = "_8d-5";
export var fulfillmentGroupTable = "_8d-e";
export var largeText = "_8d-3";
export var loadingSpinnerContainer = "_8d-j";
export var mediumText = "_8d-2";
export var narrow = "_8d-f";
export var notificationLink = "_8d-l";
export var packageCheckIconContainer = "_8d-7";
export var slideoutHeaderActions = "_8d-g";
export var slideoutHeaderActionsShifted = "_8d-h";
export var slideoutHeaderContainer = "_8d-a";
export var slideoutModal = "_8d-c";
export var stickyHeaderWrapper = "_8d-b";
export var table = "_8d-k";
export var tableContainer = "_8d-d";
export var tertiaryText = "_8d-1";